(function () {
  var captureRoot = document.querySelector('[data-guide-capture]');

  if (!captureRoot) {
    return;
  }

  var captureEndpoint = captureRoot.getAttribute('data-capture-endpoint') || '';
  var configuredGuideUrl = captureRoot.getAttribute('data-guide-url') || '';
  var turnstileSiteKey = captureRoot.getAttribute('data-turnstile-site-key') || '';
  var consentVersion = captureRoot.getAttribute('data-consent-version') || '';
  var forms = Array.prototype.slice.call(document.querySelectorAll('[data-guide-form]'));
  var success = document.querySelector('[data-guide-success]');
  var openGuide = document.querySelector('[data-guide-open]');
  var finalBand = document.getElementById('finalInvite');
  var firstTouchKey = 'abp_first_touch';
  var firstTouchSessionKey = 'abp_first_touch_session';
  var leadIdKey = 'abp_lead_id';
  var applicationTrackingKey = 'abp4:tracking';
  var busy = false;
  var acquisition = captureAcquisition();
  var turnstileStates = [];

  function clean(value, maxLength) {
    if (!value) {
      return '';
    }

    return String(value)
      .replace(/[\r\n\t]+/g, ' ')
      .replace(/\s{2,}/g, ' ')
      .trim()
      .slice(0, maxLength || 1024);
  }

  function uuidV7() {
    var bytes = new Uint8Array(16);
    var timestamp = Date.now();
    var index;

    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      window.crypto.getRandomValues(bytes);
    } else {
      for (index = 0; index < bytes.length; index += 1) {
        bytes[index] = Math.floor(Math.random() * 256);
      }
    }

    for (index = 5; index >= 0; index -= 1) {
      bytes[index] = timestamp % 256;
      timestamp = Math.floor(timestamp / 256);
    }

    bytes[6] = (bytes[6] & 15) | 112;
    bytes[8] = (bytes[8] & 63) | 128;

    return Array.prototype.map.call(bytes, function (byte) {
      return byte.toString(16).padStart(2, '0');
    }).join('').replace(
      /^(.{8})(.{4})(.{4})(.{4})(.{12})$/,
      '$1-$2-$3-$4-$5'
    );
  }

  function isUuidV7(value) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value || '');
  }

  function isThemePreview() {
    var params = new URLSearchParams(window.location.search);
    var hostname = window.location.hostname.toLowerCase();
    var themeRole = String(
      window.Shopify &&
      window.Shopify.theme &&
      window.Shopify.theme.role || ''
    ).toLowerCase();

    return Boolean(
      params.get('preview_theme_id') ||
      /\.myshopify\.com$/.test(hostname) ||
      (window.Shopify && window.Shopify.designMode) ||
      (themeRole && themeRole !== 'main')
    );
  }

  function sourceClass(values) {
    var medium = (values.utm_medium || '').toLowerCase();

    if (values.gclid || values.gbraid || values.wbraid || /^(cpc|ppc|paidsearch|paid_search)$/.test(medium)) {
      return 'paid_search';
    }

    if (/^(paid_social|paidsocial|social_paid)$/.test(medium)) {
      return 'paid_social';
    }

    if (medium === 'email') {
      return 'email';
    }

    if (values.utm_source || values.utm_medium || values.utm_campaign) {
      return 'campaign';
    }

    if (values.referrer_host && values.referrer_host !== window.location.hostname) {
      return 'referral';
    }

    return 'direct';
  }

  function currentAcquisition() {
    var params = new URLSearchParams(window.location.search);
    var referrerHost = '';

    if (document.referrer) {
      try {
        referrerHost = new URL(document.referrer).hostname;
      } catch (error) {
        referrerHost = '';
      }
    }

    var values = {
      utm_source: clean(params.get('utm_source'), 255),
      utm_medium: clean(params.get('utm_medium'), 255),
      utm_campaign: clean(params.get('utm_campaign'), 255),
      utm_content: clean(params.get('utm_content'), 255),
      utm_term: clean(params.get('utm_term'), 255),
      gclid: clean(params.get('gclid'), 255),
      gbraid: clean(params.get('gbraid'), 255),
      wbraid: clean(params.get('wbraid'), 255),
      first_touch_url: clean(window.location.href.split('#')[0], 2048),
      landing_path: clean(window.location.pathname, 512),
      referrer: clean(document.referrer, 2048),
      referrer_host: clean(referrerHost, 255),
      first_touch_at_utc: new Date().toISOString()
    };

    values.source_class = sourceClass(values);

    return values;
  }

  function normalizeStoredAcquisition(stored) {
    if (!stored || typeof stored !== 'object') {
      return null;
    }

    var values = {
      utm_source: clean(stored.utm_source, 255),
      utm_medium: clean(stored.utm_medium, 255),
      utm_campaign: clean(stored.utm_campaign, 255),
      utm_content: clean(stored.utm_content, 255),
      utm_term: clean(stored.utm_term, 255),
      gclid: clean(stored.gclid, 255),
      gbraid: clean(stored.gbraid, 255),
      wbraid: clean(stored.wbraid, 255),
      first_touch_url: clean(stored.first_touch_url, 2048),
      landing_path: clean(stored.landing_path, 512),
      referrer: clean(stored.referrer, 2048),
      referrer_host: clean(stored.referrer_host, 255),
      first_touch_at_utc: clean(stored.first_touch_at_utc, 64),
      source_class: clean(stored.source_class, 64)
    };

    if (!values.first_touch_url || !values.first_touch_at_utc) {
      return null;
    }

    if (!values.landing_path) {
      try {
        values.landing_path = clean(new URL(values.first_touch_url).pathname, 512);
      } catch (error) {
        values.landing_path = '';
      }
    }

    if (!values.source_class) {
      values.source_class = sourceClass(values);
    }

    return values;
  }

  function captureAcquisition() {
    var stored = null;

    try {
      stored = normalizeStoredAcquisition(JSON.parse(localStorage.getItem(firstTouchKey)));
    } catch (error) {
      stored = null;
    }

    if (!stored) {
      try {
        stored = normalizeStoredAcquisition(JSON.parse(sessionStorage.getItem(firstTouchSessionKey)));
      } catch (error) {
        stored = null;
      }
    }

    if (stored) {
      return stored;
    }

    var current = currentAcquisition();

    try {
      sessionStorage.setItem(firstTouchSessionKey, JSON.stringify(current));
    } catch (error) {
      // Attribution still travels with this submission when storage is unavailable.
    }

    return current;
  }

  function existingLeadId() {
    var leadId = '';

    if (isThemePreview()) {
      return '';
    }

    try {
      var tracking = JSON.parse(sessionStorage.getItem(applicationTrackingKey));

      if (tracking && isUuidV7(tracking.leadId)) {
        return tracking.leadId;
      }
    } catch (error) {
      // Fall through to the accepted persistent identifier.
    }

    try {
      leadId = localStorage.getItem(leadIdKey) || '';
    } catch (error) {
      leadId = '';
    }

    return isUuidV7(leadId) ? leadId : '';
  }

  function addPresentFields(target, values) {
    Object.keys(values).forEach(function (key) {
      if (values[key] !== '' && values[key] !== null && typeof values[key] !== 'undefined') {
        target[key] = values[key];
      }
    });
  }

  function clarityCommand() {
    var args = Array.prototype.slice.call(arguments);

    if (typeof window.clarity !== 'function') {
      window.clarity = function () {
        window.clarity.q = window.clarity.q || [];
        window.clarity.q.push(arguments);
      };
    }

    window.clarity.apply(window, args);
  }

  function trackOpenAI(eventName, payload) {
    if (payload.is_synthetic || typeof window.oaiq !== 'function') {
      return;
    }

    var options = { event_id: payload.event_id };

    if (eventName === 'abp_page_view') {
      window.oaiq('measure', 'page_viewed', {
        type: 'contents',
        contents: [{
          id: 'authority-book-buyers-guide',
          name: 'Authority Book Buyer\'s Guide',
          content_type: 'page'
        }]
      }, options);
    } else if (eventName === 'abp_guide_opt_in') {
      window.oaiq('measure', 'custom', {
        type: 'custom'
      }, {
        event_id: payload.event_id,
        custom_event_name: 'authority_guide_opt_in'
      });
    }
  }

  function track(eventName, details) {
    var payload = {
      event: eventName,
      event_id: uuidV7(),
      event_name: eventName,
      event_version: 1,
      occurred_at_utc: new Date().toISOString(),
      source_system: 'web',
      reporting_timezone: 'America/Toronto',
      abp_funnel_slug: 'authority-book-program',
      page_surface: 'authority-book-buyers-guide',
      page_path: window.location.pathname,
      page_version: 'v2',
      is_synthetic: isThemePreview()
    };

    if (payload.is_synthetic) {
      payload.debug_mode = true;
    }

    addPresentFields(payload, {
      source_class: acquisition.source_class,
      landing_path: acquisition.landing_path,
      utm_source: acquisition.utm_source,
      utm_medium: acquisition.utm_medium,
      utm_campaign: acquisition.utm_campaign,
      utm_content: acquisition.utm_content,
      utm_term: acquisition.utm_term
    });
    addPresentFields(payload, details || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    trackOpenAI(eventName, payload);
  }

  function validHttpUrl(value) {
    if (!value) {
      return '';
    }

    try {
      var url = new URL(value, window.location.origin);

      if (url.protocol !== 'http:' && url.protocol !== 'https:') {
        return '';
      }

      return url.href;
    } catch (error) {
      return '';
    }
  }

  function setError(form, message) {
    var error = form.querySelector('.gf__err');

    if (message) {
      error.textContent = message;
      error.hidden = false;
    } else {
      error.textContent = '';
      error.hidden = true;
    }
  }

  function setBusy(nextBusy, activeButton, originalLabel) {
    busy = nextBusy;

    forms.forEach(function (form) {
      var button = form.querySelector('button[type="submit"]');
      button.disabled = nextBusy;
    });

    if (activeButton) {
      activeButton.textContent = nextBusy ? 'Sending your Guide...' : originalLabel;
    }
  }

  function persistAcceptedLead(leadId) {
    if (isThemePreview()) {
      return;
    }

    try {
      localStorage.setItem(leadIdKey, leadId);
      localStorage.setItem(firstTouchKey, JSON.stringify(acquisition));
    } catch (error) {
      // The accepted response remains authoritative when browser storage is unavailable.
    }

    try {
      var existingTracking = null;

      try {
        existingTracking = JSON.parse(sessionStorage.getItem(applicationTrackingKey));
      } catch (error) {
        existingTracking = null;
      }

      var applicationTracking = {
        leadId: leadId,
        isSynthetic: false,
        sent: existingTracking &&
          existingTracking.leadId === leadId &&
          existingTracking.sent &&
          typeof existingTracking.sent === 'object'
          ? existingTracking.sent
          : {}
      };
      sessionStorage.setItem(applicationTrackingKey, JSON.stringify(applicationTracking));
    } catch (error) {
      // The application can recover the lead ID from local storage in a later session.
    }
  }

  function showSuccess(guideUrl) {
    forms.forEach(function (form) {
      form.hidden = true;
    });

    openGuide.href = guideUrl;
    openGuide.hidden = false;
    success.hidden = false;
    finalBand.hidden = true;

    var y = success.getBoundingClientRect().top + window.scrollY - 120;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    try {
      window.scrollTo({
        top: Math.max(y, 0),
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    } catch (error) {
      window.scrollTo(0, Math.max(y, 0));
    }

    try {
      success.focus({ preventScroll: true });
    } catch (error) {
      success.focus();
    }
  }

  function captureGuide(payload) {
    var endpoint = validHttpUrl(captureEndpoint);

    if (!endpoint) {
      return Promise.reject(new Error('Capture service is not configured.'));
    }

    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timeout = window.setTimeout(function () {
      if (controller) {
        controller.abort();
      }
    }, 15000);

    return fetch(endpoint, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      signal: controller ? controller.signal : undefined,
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Capture service rejected the request.');
      }

      return response.json();
    }).then(function (result) {
      var leadId = clean(result && (result.abp_lead_id || result.lead_id), 64);
      var guideUrl = validHttpUrl(result && result.guide_url);
      var approvedGuideUrl = validHttpUrl(configuredGuideUrl);

      if (
        !result ||
        result.accepted !== true ||
        result.delivery_accepted !== true ||
        !isUuidV7(leadId) ||
        !guideUrl ||
        !approvedGuideUrl ||
        guideUrl !== approvedGuideUrl
      ) {
        throw new Error('Capture service returned a partial response.');
      }

      return {
        leadId: leadId,
        guideUrl: guideUrl
      };
    }).finally(function () {
      window.clearTimeout(timeout);
    });
  }

  clarityCommand('set', 'funnel', 'authority-book-program');
  clarityCommand('set', 'page_surface', 'buyers-guide');
  clarityCommand('set', 'page_version', 'v2');
  track('abp_page_view');

  function turnstileState(form) {
    for (var index = 0; index < turnstileStates.length; index += 1) {
      if (turnstileStates[index].form === form) {
        return turnstileStates[index];
      }
    }

    return null;
  }

  function resetVerification(state) {
    if (
      state &&
      typeof state.widgetId !== 'undefined' &&
      window.turnstile &&
      typeof window.turnstile.reset === 'function'
    ) {
      window.turnstile.reset(state.widgetId);
    }
  }

  function stopPendingSubmission(state, message) {
    if (!state || !state.pending) {
      return;
    }

    var pending = state.pending;
    state.pending = null;
    setError(state.form, message);
    setBusy(false, pending.button, pending.originalLabel);
  }

  function captureVerifiedSubmission(state, token) {
    if (!state || !state.pending || !token) {
      stopPendingSubmission(
        state,
        'We could not verify your submission. Please try again.'
      );
      resetVerification(state);
      return;
    }

    var pending = state.pending;

    captureGuide({
      email: pending.email,
      consent: true,
      consent_version: consentVersion,
      turnstile_token: token,
      attribution: acquisition,
      existing_abp_lead_id: existingLeadId() || null,
      is_synthetic: isThemePreview()
    }).then(function (accepted) {
      state.pending = null;
      persistAcceptedLead(accepted.leadId);
      track('abp_guide_opt_in', {
        abp_lead_id: accepted.leadId
      });
      clarityCommand('event', 'abp_guide_opt_in');
      showSuccess(accepted.guideUrl);
    }).catch(function () {
      state.pending = null;
      setError(state.form, 'We could not send the Guide. Please try again.');
      resetVerification(state);
    }).finally(function () {
      setBusy(false, pending.button, pending.originalLabel);
    });
  }

  function initializeTurnstile() {
    if (
      !turnstileSiteKey ||
      !window.turnstile ||
      typeof window.turnstile.render !== 'function'
    ) {
      return;
    }

    forms.forEach(function (form) {
      var container = form.querySelector('[data-turnstile-widget]');
      var state = {
        form: form,
        pending: null,
        widgetId: undefined
      };

      turnstileStates.push(state);
      state.widgetId = window.turnstile.render(container, {
        sitekey: turnstileSiteKey,
        action: 'authority_book_guide',
        appearance: 'interaction-only',
        execution: 'execute',
        callback: function (token) {
          captureVerifiedSubmission(state, token);
        },
        'expired-callback': function () {
          stopPendingSubmission(
            state,
            'Your security check expired. Please try again.'
          );
          resetVerification(state);
        },
        'error-callback': function () {
          stopPendingSubmission(
            state,
            'We could not verify your submission. Please try again.'
          );
        }
      });
    });
  }

  initializeTurnstile();

  forms.forEach(function (form) {
    var email = form.querySelector('input[type="email"]');
    var consent = form.querySelector('input[type="checkbox"]');

    email.addEventListener('input', function () {
      email.removeAttribute('aria-invalid');
      setError(form, '');
    });

    consent.addEventListener('change', function () {
      consent.removeAttribute('aria-invalid');
      setError(form, '');
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (busy) {
        return;
      }

      var value = email.value.trim();
      var button = form.querySelector('button[type="submit"]');
      var originalLabel = button.textContent;

      if (!value || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) {
        email.setAttribute('aria-invalid', 'true');
        setError(form, 'Enter a valid email address.');
        email.focus();
        return;
      }

      email.removeAttribute('aria-invalid');

      if (!consent.checked) {
        consent.setAttribute('aria-invalid', 'true');
        setError(form, 'Confirm that we may email you the Guide and its related email series.');
        consent.focus();
        return;
      }

      consent.removeAttribute('aria-invalid');
      setError(form, '');
      var state = turnstileState(form);

      if (
        !turnstileSiteKey ||
        !state ||
        typeof state.widgetId === 'undefined' ||
        !window.turnstile ||
        typeof window.turnstile.execute !== 'function'
      ) {
        setError(form, 'We could not send the Guide. Please try again.');
        return;
      }

      state.pending = {
        email: value,
        button: button,
        originalLabel: originalLabel
      };
      setBusy(true, button, originalLabel);

      try {
        window.turnstile.execute(state.widgetId);
      } catch (error) {
        stopPendingSubmission(
          state,
          'We could not verify your submission. Please try again.'
        );
      }
    });
  });
})();
